import * as Factory from 'factory.ts'
import faker from 'faker'

import { AccountMock } from './account.factory'
import { DepartmentMock } from './department.factory'
import { type Budget, type DepartmentBudget } from '../../models'

const mockStartDate = faker.date.between('2015-01-01', '2020-12-30')

export const BudgetMock = Factory.Sync.makeFactory<Budget>({
  id: Factory.each(() => faker.random.number()),
  account: Factory.each(() => AccountMock.build()),
  budget: Factory.each(() => faker.random.number(1000).toString()),
  purchased: Factory.each(() => faker.random.number(300).toString()),
  approved: Factory.each(() => faker.random.number(300).toString()),
  pending: Factory.each(() => faker.random.number(300).toString()),
  invoiced: Factory.each(() => faker.random.number(300).toString()),
  startDate: Factory.each(() => mockStartDate.toISOString()),
  endDate: Factory.each(() =>
    faker.date.between(mockStartDate, '2020-12-31').toISOString()
  ),
  is_expired: Factory.each(() => faker.random.boolean()),
  is_closed: false,
  department: Factory.each(() => DepartmentMock.build()),
})

export const DepartmentBudgetMock = Factory.Sync.makeFactory<DepartmentBudget>({
  budget: Factory.each(() => faker.random.number(1000).toString()),
  purchased: Factory.each(() => faker.random.number(300).toString()),
  approved: Factory.each(() => faker.random.number(300).toString()),
  pending: Factory.each(() => faker.random.number(300).toString()),
  invoiced: Factory.each(() => faker.random.number(300).toString()),
  startDate: Factory.each(() => mockStartDate.toISOString()),
  endDate: Factory.each(() =>
    faker.date.between(mockStartDate, '2020-12-31').toISOString()
  ),
  department: Factory.each(() => DepartmentMock.build()),
})
